
import alertify from 'alertify';
import Swiper from 'vux/src/components/swiper/swiper.vue'

import api from '../api';
import { initBim } from '@/logic/bim';

let mountedFlag = false;
let bimInitFlag = false;

export default {
name: 'project-detail',
data() {
return {
showTarget: '3d',
screenWidth: null,
project: null,
viewToken: null,
show3dDisplayLoading: true,
};
},
computed: {
swiperList() {
if (!this.project || !this.project.image_gallery) {
return [];
}

return this.project.image_gallery.map(img => {
return {
url: 'javascript:',
img: img.url,
};
});
},
},
methods: {
changeShowTaget(target) {
this.showTarget = target;
},
},
created() {
const id = parseInt(this.$route.params.id);
api.get(id).then(({ item }) => {
this.project = item;
})
.then(() => {
if (!this.project.is_bim_file_ready) {
return Promise.reject('Bimface的构件未准备好');
}
return api.getViewToken(this.project.file_id);
})
.then(data => {
this.viewToken = data.view_token;

if (mountedFlag && !bimInitFlag) {
const initBimResult = initBim(this.viewToken);
if (initBimResult) {
this.show3dDisplayLoading = false;
bimInitFlag = true;
}
}
})
.catch(error => {
this.changeShowTaget('2d');
alertify.error(error);
});
},
mounted() {
this.screenWidth = document.body.clientWidth;
mountedFlag = true;

if (!!this.viewToken && !bimInitFlag) {
const initBimResult = initBim(this.viewToken);
if (initBimResult) {
bimInitFlag = true;
}
}

},
}



// WEBPACK FOOTER //
// ./src/pages/project/detail/index.vue